module.exports = __webpack_public_path__ + "static/media/firmCheck.b2e5ac57.svg";